import React from "react"

import "./NavbarOptions.css"

function NavbarOptions(props) {
    const { linkComponent: LinkComponent, items = [], fieldId = "" } = props
    return (
        <>
            <div className="navbar__options">
                {items.map((item, index) => {
                    const { to, name } = item
                    return (
                        <LinkComponent
                            key={"navbar-option-" + index}
                            to={"/" + to + "/" + fieldId}
                            id={`${String(name).toLocaleLowerCase()}__nav-option__navbar`}
                        >
                            <div className="navbar__option__item">{name}</div>
                        </LinkComponent>
                    )
                })}
            </div>
        </>
    )
}

export default NavbarOptions
